import type { OnlineType } from './OnlineType';

export enum DocsSiteVisitType {
  CustomDomain = 'customDomain',
  WithId = 'withId',
}

export type DocsIdTypeData =
  | {
      onlineType: OnlineType.DocsSite;
      onlineId: number;
      visitType: DocsSiteVisitType;
      projectId: number;
      teamId: number;
      branchId: number | undefined;
      subdirectory: string;
    }
  | {
      onlineType: OnlineType.SharedDoc;
      onlineId: string;
      projectId: number;
      teamId: number;
    };
